import {Coins, HandshakeIcon, LayoutTemplate} from "lucide-react";
import {PageHeader, PageLayout, PageNav, PageNavItem, PageTitle} from "@/util-components/page-layout";

/**
 * Page-Wrapper für den Sponsoren-Bereich (mit Tabs & Routing)
 */
function SponsorsV2Wrapper() {
  return (
      <PageLayout
          basePath={"/sponsoring"}
          resolveDefaultTab={() => "sponsoren"}
          suspenseType="blue"
      >
        <PageHeader>
          <PageTitle
              title={"Sponsoring"}
              icon={Coins}
              iconColor="text-blue-600"
              iconBg="bg-blue-50"
          />

          <PageNav>
            <PageNavItem value={"sponsoren"} label={"Sponsoren"} icon={HandshakeIcon} />
            <PageNavItem value={"leistungen"} label={"Leistungen"} icon={LayoutTemplate} />
          </PageNav>
        </PageHeader>
      </PageLayout>
  );
}

export default SponsorsV2Wrapper;
